module.exports = __webpack_public_path__ + "static/fonts/aeonik-light.7930f043.woff2";